export const moedaPublica = centavos => (centavos / 100).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

// O total exibido vem das mesmas linhas que podem ser enviadas, nunca de
// um total antigo gravado no documento. Calcula em centavos por unidade.
export function resumoOrcamentoPublico(orcamento) {
  const linhas = (orcamento?.itens || []).map((item, index) => {
    const quantidade = Number(item.quantidade ?? 1);
    const preco = Number(item.preco ?? 0);
    const unitario = Math.round((preco + Number.EPSILON) * 100);
    const valido = Number.isSafeInteger(quantidade) && quantidade > 0 && Number.isFinite(preco) && preco >= 0 && Number.isSafeInteger(unitario * quantidade);
    return { index, quantidade, unitario, subtotal: valido ? unitario * quantidade : 0, valido, aprovado: !!orcamento.aprovados?.[index], enviado: !!orcamento.pedidosRegistrados?.[index] };
  });
  const pendentes = linhas.filter(l => l.aprovado && !l.enviado);
  const total = linhas.reduce((s, l) => s + l.subtotal, 0);
  return { linhas, pendentes, total, aprovado: pendentes.reduce((s, l) => s + l.subtotal, 0), enviado: linhas.filter(l => l.enviado).reduce((s, l) => s + l.subtotal, 0), valido: linhas.every(l => l.valido) && Number.isSafeInteger(total) };
}
